module.exports = __webpack_public_path__ + "img/ic_check_w.a6b8ed5b.svg";